import React from 'react';
import { useParams } from 'react-router-dom';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import PageHeader from '../../components/PageHeader/PageHeader';
import './BirimDetay.css';

const BirimDetay = () => {
  const { id } = useParams();

  const birimData = {
    birimAdi: "UÇAK MÜHENDİSLİĞİ",
    toplamMakale: {
      yil2024: 30,
      sonBesYil: 168
    },
    istatistikler: {
      q1: { yil2024: 17 },
      q2: { yil2024: 11 },
      d: { yil2024: 2 }
    },
    ozet: {
      ogretimUyesiSayisi: 20,
      ogretimUyesiBasinaQ1Q2: 1.40,
      ogretimUyesiBasinaQ1: 0.85,
      ogretimUyesiBasinaQ2: 0.55,
      q1q2Toplam: 28
    },
    yuzdelik: {
      q1: 56.7,
      q2: 36.7,
      q1q2: 93.3
    },
    yillikVeriler: {
      yillar: ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"],
      veriler: {
        itu: [85.0, 82.0, 81.0, 82.0, 85.0, 85.0, 85.0, 82.3, 91.8],
        ucakUzayFak: [73.8, 77.1, 77.3, 75.2, 88.2, 84.8, 82.3, 89.1, 93.3],
        bilimTeknoloji: [42.9, 77.8, 70.0, 75.0, 65.2, 83.3, 89.9, 84.2, 100.0],
        ucakMuh: [79.1, 72.4, 65.2, 75.3, 93.9, 83.3, 81.3, 90.3, 93.3],
        uzayMuh: [72.7, 80.0, 88.7, 85.7, 100.0, 100.0, 85.0, 92.9, 83.3]
      }
    }
  };

  const q1q2YuzdesiOptions = {
    chart: {
      type: 'line'
    },
    title: {
      text: 'Q1 + Q2 Yüzdesi'
    },
    xAxis: {
      categories: birimData.yillikVeriler.yillar
    },
    yAxis: {
      title: {
        text: 'Yüzde (%)'
      },
      min: 0,
      max: 100
    },
    plotOptions: {
      line: {
        marker: {
          enabled: true
        }
      }
    },
    series: [
      {
        name: 'İTÜ',
        data: birimData.yillikVeriler.veriler.itu,
        color: '#4CAF50'
      },
      {
        name: 'Uçak ve Uzay Bilimleri Fakültesi',
        data: birimData.yillikVeriler.veriler.ucakUzayFak,
        color: '#2196F3'
      },
      {
        name: 'Bilim İnsanı ve Teknoloji Geliştirme',
        data: birimData.yillikVeriler.veriler.bilimTeknoloji,
        color: '#FFC107'
      },
      {
        name: 'Uçak Mühendisliği',
        data: birimData.yillikVeriler.veriler.ucakMuh,
        color: '#9C27B0'
      },
      {
        name: 'Uzay Mühendisliği',
        data: birimData.yillikVeriler.veriler.uzayMuh,
        color: '#FF5722'
      }
    ]
  };

  return (
    <div className="wrapper">
      <PageHeader 
        title={birimData.birimAdi}
        description="Birim Detay Sayfası"
      />

      <div className="stats-cards">
        <div className="stat-card total-articles">
          <div className="stat-value">
            <span className="current">{birimData.toplamMakale.yil2024}</span>
            <span className="total">{birimData.toplamMakale.sonBesYil}</span>
          </div>
          <div className="stat-label">
            <div>Toplam Makale (2024)</div>
            <div>Toplam Makale (Son Beş Yıl)</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-header">Q1 (2024)</div>
          <div className="stat-value">{birimData.istatistikler.q1.yil2024}</div>
          <div className="stat-footer">Son Beş Yıl</div>
        </div>

        <div className="stat-card">
          <div className="stat-header">Q2 (2024)</div>
          <div className="stat-value">{birimData.istatistikler.q2.yil2024}</div>
          <div className="stat-footer">Son Beş Yıl</div>
        </div>

        <div className="stat-card">
          <div className="stat-header">D (2024)</div>
          <div className="stat-value">{birimData.istatistikler.d.yil2024}</div>
          <div className="stat-footer">Son Beş Yıl</div>
        </div>
      </div>

      <div className="summary-section">
        <h2>Özet Bilgiler</h2>
        <div className="metrics-grid">
          <div className="metric-item">
            <span className="label">Öğretim Üyesi Sayısı</span>
            <span className="value">{birimData.ozet.ogretimUyesiSayisi}</span>
          </div>
          <div className="metric-item">
            <span className="label">Öğretim Üyesi Başına Q1 + Q2 (2024)</span>
            <span className="value">{birimData.ozet.ogretimUyesiBasinaQ1Q2}</span>
          </div>
          <div className="metric-item">
            <span className="label">Öğretim Üyesi Başına Q1 (2024)</span>
            <span className="value">{birimData.ozet.ogretimUyesiBasinaQ1}</span>
          </div>
          <div className="metric-item">
            <span className="label">Öğretim Üyesi Başına Q2 (2024)</span>
            <span className="value">{birimData.ozet.ogretimUyesiBasinaQ2}</span>
          </div>
          <div className="metric-item">
            <span className="label">Q1 + Q2 (2024)</span>
            <span className="value">{birimData.ozet.q1q2Toplam}</span>
          </div>
        </div>
      </div>

      <div className="percentages-section">
        <div className="percentage-item">
          <span className="label">Q1 Yüzdesi</span>
          <span className="value">%{birimData.yuzdelik.q1}</span>
        </div>
        <div className="percentage-item">
          <span className="label">Q2 Yüzdesi</span>
          <span className="value">%{birimData.yuzdelik.q2}</span>
        </div>
        <div className="percentage-item">
          <span className="label">Q1 + Q2 Yüzdesi</span>
          <span className="value">%{birimData.yuzdelik.q1q2}</span>
        </div>
      </div>

      <div className="charts-section">
        <div className="chart-container">
          <HighchartsReact 
            highcharts={Highcharts} 
            options={q1q2YuzdesiOptions}
          />
        </div>
      </div>

      <div className="comparison-table">
        <h2>Yıllara Göre Karşılaştırma</h2>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th></th>
                {birimData.yillikVeriler.yillar.map(yil => (
                  <th key={yil}>{yil}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>İTÜ</td>
                {birimData.yillikVeriler.veriler.itu.map((deger, idx) => (
                  <td key={idx}>%{deger.toFixed(1)}</td>
                ))}
              </tr>
              <tr>
                <td>Uçak ve Uzay Bilimleri Fakültesi</td>
                {birimData.yillikVeriler.veriler.ucakUzayFak.map((deger, idx) => (
                  <td key={idx}>%{deger.toFixed(1)}</td>
                ))}
              </tr>
              <tr>
                <td>Bilim İnsanı ve Teknoloji Geliştirme</td>
                {birimData.yillikVeriler.veriler.bilimTeknoloji.map((deger, idx) => (
                  <td key={idx}>%{deger.toFixed(1)}</td>
                ))}
              </tr>
              <tr>
                <td>Uçak Mühendisliği</td>
                {birimData.yillikVeriler.veriler.ucakMuh.map((deger, idx) => (
                  <td key={idx}>%{deger.toFixed(1)}</td>
                ))}
              </tr>
              <tr>
                <td>Uzay Mühendisliği</td>
                {birimData.yillikVeriler.veriler.uzayMuh.map((deger, idx) => (
                  <td key={idx}>%{deger.toFixed(1)}</td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BirimDetay; 